import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import renderIf from '../../../pkgs/render_if';

import AsyncSelect from 'react-select/lib/Async';

import {
  FormControl,
  HelpBlock,
} from 'react-bootstrap';

export default class ManyToManyField extends React.Component {

    constructor(props){
      super(props);
      this.state = {
        inputValue:[],
        options:[],
        options_loading: true,
      };
    }

    loadOptions = (inputValue, callback) => {
        setTimeout(() => {
            //callback(filterColors(inputValue));
            let app_label = this.props.app_label;
            let model_name = this.props.model_name;
            $.ajax({
              url: '/api/awesomplete/' + app_label + '/' + model_name + '/',
              dataType: 'json',
              cache: false,
              headers: {'Authorization': 'Token ' + localStorage.token},
              success: (options) => {
                  this.props.clearEditingInstance();
                  this.setState({options, options_loading:false});
                   callback(options);
              }
            })
        }, 250);
    }

    logChange = (returned_object) => {
      let instances = [];
      for (var key in returned_object) {
          instances.push(returned_object[key]['value']);
      }
      this.props.onSelectChange(this.props.data_key, instances);
    }

    render() {
        // console.log('AsyncSelect render()')
        let options = [];
        let async_select = [];
        let prop_values = this.props.editingInstance[this.props.field_id];
        if (this.state.options_loading === false) {
            if (prop_values) {
                let state_options = this.state.options;
                for (var key in prop_values) {
                    for (var key1 in state_options) {
                        if (prop_values[key] === state_options[key1]['value']) {
                            options.push(state_options[key1]['label']);
                        }
                    }
                }
            }
        }
        return (
            <div>
              <AsyncSelect
                  defaultValue={options}
                  cacheOptions
                  isMulti
                  loadOptions={this.loadOptions}
                  defaultOptions
                  onInputChange={this.logChange}
              />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/helpers/field/many_to_many_field.js